// extracted by mini-css-extract-plugin
export default {"navBox":"pc_navBox__rBLS9","navList":"pc_navList__dy+aY","navItem":"pc_navItem__jUJoa","navActive":"pc_navActive__wUTjq"};